export { default as BMI } from './BMI';
